import { combineReducers } from "redux";
import storage from "redux-persist/lib/storage/session";
import { persistReducer } from "redux-persist";
import candidateAuthReducer from "./features/candidate/candidateAuthSlice";
import timerReducer from "./features/timer/timerSlice";
import audioReducer from "./features/audioDetection/audioSlice";
import fullscreenReducer from "./features/fullScreen/fullScreenSlice";
import snapshotReducer from "./features/snapshot/snapshotSlice";
import warningReducer from "./features/warning/warningSlice";
import examDetailReducer from "./features/examDetails/examDetailsSlice";
import authReducer from "./features/authVerification/authSlice";
import questionsReducer from "./features/questions/questionSlice";

const authPersistConfig = {
  key: "auth",
  storage: storage,
  blacklist: ["loading"],
};
const timerPersistConfig = {
  key: "timer",
  storage: storage,
  blacklist: [
    "cam1Start",
    "cam2Start",
    "submitShow",
    "faceAPIloaded",
    "counterIntervalId",
  ],
};
const snapshotPersistConfig = {
  key: "snapshot",
  storage: storage,
  blacklist: ["snapshotLog"],
};
const fullscreenPersistConfig = {
  key: "fullscreen",
  storage: storage,
  blacklist: ["isFullscreen"],
};

export default combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  candidateAuth: candidateAuthReducer,
  timer: persistReducer(timerPersistConfig, timerReducer),
  examDetail: examDetailReducer,
  audio: audioReducer,
  fullscreen: persistReducer(fullscreenPersistConfig, fullscreenReducer),
  snapshot: persistReducer(snapshotPersistConfig, snapshotReducer),
  warning: warningReducer,
  questions: questionsReducer,
});
